import { withStyles } from '@material-ui/styles';
import React from 'react';
import Select from 'react-select';
import { reactSelectDefaultStyles } from '../../../consts/reactSelectDefaultStyles';

import styles, {
  customSelectStyles,
  groupbySelectStyles
} from '../styles/selects';

const GroupingSelector = ({ setFunction, value, classes, options, name }) => {
  const handleChange = selected => {
    setFunction(selected.value);
  };

  return (
    <div className={classes.root}>
      <div className={classes.label}>{name}</div>
      <Select
        customStyles={{ ...customSelectStyles, ...groupbySelectStyles }}
        options={options}
        styles={reactSelectDefaultStyles}
        value={options.find(option => option.value === value)}
        onChange={handleChange}
        isRtl
        isSearchable={false}
      />
    </div>
  );
};

export default withStyles(styles)(GroupingSelector);
